import React from 'react';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import { secondsToHms } from "../../utils";
import './recording-list.css';
import { PlayArrowOutlined } from '@material-ui/icons';

const RecordingItem = ({ duration, recordingId, href, recCount, idx, isPosterImgPortrait, mode, poster }) => {
  const getRecordingItemText = () => {
    if (mode === 'portrait' && !isPosterImgPortrait && recCount > 2) {
      return `REC - PART ${idx + 1}`;
    }
    if (recCount >= 2) {
      return `VIEW RECORDING - PART ${idx + 1}`;
    }
  };
  return (
    <>
      {recCount === 1 ? (
        <div className="recItem">
          <a href={href} target="_blank" rel="noreferrer">
            <img src={poster} alt="Recording" />
            <div className="plyBtn">
              <PlayArrowIcon />
            </div>
            {/* <span className="recordingDuration">{secondsToHms(duration / 1000)}</span> */}
          </a>
        </div>
      ) : (
        <div className="NoThumbnailRecItem">
          <a href={href} target="_blank" rel="noreferrer">
            <div className="recText">
              <PlayArrowOutlined />
              <span>{getRecordingItemText()}</span>
            </div>
          </a>
        </div>
      )}
    </>
  );
};

export default RecordingItem;
